import { canNavigate } from '@/common/ability'

export default function checkRule({ to, next, store }) {
    if (store.getters['user/is_current_user_fetched']) {
        let rules = store.getters['user/current_user'].rules
        let owner = rules.find(rule => rule.subject === 'all')
        if(owner) {
            next()
            return
        }

        canNavigate(to.meta.rules).then(result => {
            if(result) {
                next()
                return
            }else {
                next('/access-denied')
                return
            }
        })

    }else {
        next('/')
        return
    }
}